export const FETCH_PROJECTS_PAGE = '@@projects-page/FETCH_PROJECTS_PAGE';
export const FETCH_PROJECTS_PAGE_SUCCESS = '@@projects-page/FETCH_PROJECTS_PAGE_SUCCESS';
export const FETCH_PROJECTS_PAGE_ERROR = '@@projects-page/FETCH_PROJECTS_PAGE_ERROR';

export const FETCH_PROJECTS_FILTERS = '@@projects-page/FETCH_PROJECTS_FILTERS';
export const FETCH_PROJECTS_FILTERS_SUCCESS = '@@projects-page/FETCH_PROJECTS_FILTERS_SUCCESS';
export const FETCH_PROJECTS_FILTERS_ERROR = '@@projects-page/FETCH_PROJECTS_FILTERS_ERROR';
